

import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  Autocomplete,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../../config';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import axios from 'axios';
import api from '../../../api/axiosInterceptor';



// Helper: convert DD/MM/YYYY to ISO YYYY-MM-DD for input[type=date]
const convertDisplayDateToISO = (dateStr) => {
  if (!dateStr) return '';
  const parts = dateStr.split('/');
  if (parts.length !== 3) return '';
  const [day, month, year] = parts;
  return `${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`;
};

export const AdminAssetFirComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [feOptions, setFeOptions] = useState([]);
  const [feLoading, setFeLoading] = useState(true);

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedFir, setSelectedFir] = useState(null);

  const [formData, setFormData] = useState({
    fir_no: '',
    fir_date: '',
    police_station: '',
    property_seized_date: '',
    fe: null,
  });

  const [formErrors, setFormErrors] = useState({});

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteFir, setDeleteFir] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
    { id: 'fe_name', field: 'fe_name', headerName: 'FE Name', width: 150 },
    { id: 'ca_name', field: 'ca_name', headerName: 'CA Name', width: 150 },
    { id: 'designation', field: 'designation', headerName: 'Designation', width: 130 },
    { id: 'phone', field: 'phone', headerName: 'Phone Number', width: 150 },
    { id: 'email', field: 'email', headerName: 'Email', width: 200 },
    { id: 'firNo', field: 'firNo', headerName: 'FIR Number', width: 150 },
    { id: 'firDate', field: 'firDate', headerName: 'FIR Date', width: 130 },
    { id: 'policeStation', field: 'policeStation', headerName: 'Police Station', width: 200 },
    { id: 'propertySeizedDate', field: 'propertySeizedDate', headerName: 'Property Seized Date', width: 160 },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchAssignedFEs();
    fetchFIRs();
  }, []);

  const fetchAssignedFEs = () => {
    setFeLoading(true);
    axios.get(`${API_BASE_URL}/home-notification/assignedfe/`)
      .then(res => setFeOptions(res.data))
      .catch(() => {
        setSnackbarMessage('Failed to load FE data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => setFeLoading(false));
  };

  const fetchFIRs = () => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/asset-mgmt/asset-fir/`)
      .then(response => {
        const apiData = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          fe_name: item.fe?.name_of_fe || '-',
          ca_name: item.fe?.name_of_ca || '-',
          designation: item.fe?.designation || '-',
          phone: item.fe?.ph_number || '-',
          email: item.fe?.email || '-',
          firNo: item.fir_no,
          firDate: item.fir_date ? new Date(item.fir_date).toLocaleDateString('en-GB') : '-',
          policeStation: item.police_station,
          propertySeizedDate: item.property_seized_date ? new Date(item.property_seized_date).toLocaleDateString('en-GB') : '-',
          feId: item.fe?.id || null,
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch(() => {
        setSnackbarMessage('Failed to load FIR data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddFir = () => {
    setIsEditMode(false);
    setSelectedFir(null);
    setFormData({
      fir_no: '',
      fir_date: '',
      police_station: '',
      property_seized_date: '',
      fe: null,
    });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (fir) => {
    const selectedFe = feOptions.find(fe => fe.id === fir.feId) || null;
    setIsEditMode(true);
    setSelectedFir(fir);
    setFormData({
      fir_no: fir.firNo || '',
      fir_date: convertDisplayDateToISO(fir.firDate),
      police_station: fir.policeStation || '',
      property_seized_date: convertDisplayDateToISO(fir.propertySeizedDate),
      fe: selectedFe,
    });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (fir) => {
    setDeleteFir(fir);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api.delete(`/asset-mgmt/asset-fir/${deleteFir.id}/`)
      .then(() => {
        setSnackbarMessage('FIR deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchFIRs();
      })
      .catch(() => {
        setSnackbarMessage('Failed to delete FIR.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteFir(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.fir_no?.trim()) errors.fir_no = 'FIR Number is required';
    if (!formData.fir_date) errors.fir_date = 'FIR Date is required';
    if (!formData.police_station?.trim()) errors.police_station = 'Police Station is required';
    if (!formData.fe) errors.fe = 'Financial Establishment is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFormSubmit = () => {
    if (!validateForm()) return;
    setSubmitLoading(true);
    const payload = {
      fir_no: formData.fir_no,
      fir_date: formData.fir_date,
      police_station: formData.police_station,
      property_seized_date: formData.property_seized_date || null,
      fe: formData.fe.id,
    };
    const request = isEditMode
      ? api.patch(`/asset-mgmt/asset-fir/${selectedFir.id}/`, payload)
      : api.post(`/asset-mgmt/asset-fir/`, payload);

    request
      .then(() => {
        setSnackbarMessage(isEditMode ? 'FIR updated successfully.' : 'FIR added successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchFIRs();
      })
      .catch(() => {
        setSnackbarMessage(isEditMode ? 'Failed to update FIR.' : 'Failed to add FIR.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setSubmitLoading(false);
        setOpenFormDialog(false);
      });
  };

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', backgroundColor: '#fff' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195,234,203,0.1)" p={2}>
        <Typography variant="h4" component="h1" fontWeight="bold">Admin Asset FIR</Typography>
        <Button variant="contained" onClick={handleAddFir}>Add FIR</Button>
      </Box>

      {loading ? <LoadingSpinner size={30} /> : (
        <TableComponent columns={columns} rows={rows} manageColumnStatus enableSort sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }} />
      )}

      {/* Add/Edit FIR Form Dialog */}
      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>{isEditMode ? 'Edit FIR' : 'Add FIR'}</DialogTitle>
        <DialogContent>
          <TextField
            label="FIR Number"
            fullWidth
            margin="dense"
            value={formData.fir_no}
            onChange={(e) => setFormData({ ...formData, fir_no: e.target.value })}
            error={!!formErrors.fir_no}
            helperText={formErrors.fir_no}
          />
          <TextField
            label="FIR Date"
            type="date"
            fullWidth
            margin="dense"
            value={formData.fir_date}
            onChange={(e) => setFormData({ ...formData, fir_date: e.target.value })}
            InputLabelProps={{ shrink: true }}
            error={!!formErrors.fir_date}
            helperText={formErrors.fir_date}
          />
          <TextField
            label="Police Station"
            fullWidth
            margin="dense"
            value={formData.police_station}
            onChange={(e) => setFormData({ ...formData, police_station: e.target.value })}
            error={!!formErrors.police_station}
            helperText={formErrors.police_station}
          />
          <TextField
            label="Property Seized Date"
            type="date"
            fullWidth
            margin="dense"
            value={formData.property_seized_date}
            onChange={(e) => setFormData({ ...formData, property_seized_date: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
          <Autocomplete
            options={feOptions}
            getOptionLabel={(option) => option.name_of_fe || ''}
            loading={feLoading}
            value={formData.fe}
            onChange={(event, newValue) => setFormData({ ...formData, fe: newValue })}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Financial Establishment"
                margin="dense"
                error={!!formErrors.fe}
                helperText={formErrors.fe}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {feLoading ? <LoadingSpinner size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}>Cancel</Button>
          <Button variant="contained" onClick={handleFormSubmit} disabled={submitLoading}>
            {submitLoading ? <LoadingSpinner size={20} /> : (isEditMode ? 'Update' : 'Add')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this FIR?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitLoading}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleDelete} disabled={submitLoading}>Delete</Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
